
function selectColor(color) {
    if (!color) return;

    var selectedColor = color.toLowerCase().replace(/\s/g, "");
    const galleryList = document.querySelector('.product__media-list');
    const allItems = document.querySelectorAll('li[data-color]');

    if (allItems.length === 0) return;


    allItems.forEach(li => {
        li.style.removeProperty('display');

        const itemColor = li.getAttribute('data-color');

        if (itemColor !== '' && itemColor !== selectedColor) {
            li.classList.add('wss-hidden');
            li.classList.remove('is-active');
        } else {
            li.classList.remove('wss-hidden');
        }
    });

    if (galleryList) {
        const firstVisibleSlide = galleryList.querySelector('li[data-color]:not(.wss-hidden)');

        if (firstVisibleSlide) {
            firstVisibleSlide.classList.add('is-active');

            if (firstVisibleSlide.parentElement) {
                firstVisibleSlide.parentElement.scrollTo({ left: 0, behavior: 'instant' });
            }
        }
    }

    const thumbnailList = document.querySelector('.thumbnail-list');
    if (thumbnailList) {
        const firstVisibleThumb = thumbnailList.querySelector('li[data-color]:not(.wss-hidden)');
        if (firstVisibleThumb) {
            thumbnailList.querySelectorAll('button').forEach(btn => btn.removeAttribute('aria-current'));
            const btn = firstVisibleThumb.querySelector('button');
            if(btn) btn.setAttribute('aria-current', 'true');
        }
    }
}

function tryUpdateImages(element) {
    let value = element.value;
    if (!value) return;

    let checkValue = value.toLowerCase().replace(/\s/g, "");

    const matchingImage = document.querySelector(`li[data-color="${checkValue}"]`);

    if (matchingImage) {
        selectColor(checkValue);
    }
}

document.addEventListener('change', function(event) {
    if (event.target.matches('input[type="radio"], select, input[type="hidden"]')) {
        tryUpdateImages(event.target);
    }
});

document.addEventListener('DOMContentLoaded', () => {
    const activeInputs = document.querySelectorAll('input[type="radio"]:checked, select');
    activeInputs.forEach(input => tryUpdateImages(input));
});